'use client';

import { useId, useState } from 'react';
import Modal from '~/common/components/Modal';
import { DemoForm } from '~/redesign/components/DemoForm';
import { useExperience } from '~/redesign/components/Experience';
import styles from './PricingOfferButton.module.scss';

export default function PricingOfferButton({ children, plan, className, ariaLabel, planLabel, source, onClick }) {
  const { locale } = useExperience();
  const copy = locale === 'en'
    ? { title: 'Let’s plan your demo', description: 'Share your contact details and let’s explore how Palmate would work for your business.', trigger: 'Schedule my demo', submit: 'Send demo request', plan: name => `Schedule a ${name} demo`, selected: name => `Selected plan: ${name}` }
    : { title: 'Demo planlayalım', description: 'İletişim bilgilerinizi paylaşın, Palmate’in işletmenizde nasıl çalışacağını birlikte görelim.', trigger: 'Demo görüşmemi planla', submit: 'Demo talebini gönder', plan: name => `${name} için demo planla`, selected: name => `Seçilen paket: ${name}` };
  const buttonLabel = planLabel ? copy.plan(planLabel) : copy.trigger;
  const id = useId();
  const idPrefix = `pricing-demo-${id}`;
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const close = () => {
    if (!submitting) setOpen(false);
  };

  return <>
    <button type="button" className={className} aria-label={ariaLabel || (children ? undefined : buttonLabel)} onClick={() => { onClick?.(); setOpen(true); }}>{children || buttonLabel}</button>
    <Modal
      idPrefix={idPrefix}
      title={copy.title}
      open={open}
      onClose={close}
      closeOnBackdrop={!submitting}
      panelClassName={styles.panel}
    >
      <p className={styles.description}>{copy.description}</p>
      {planLabel && <p className={styles.description}><strong>{copy.selected(planLabel)}</strong></p>}
      <DemoForm
        idPrefix={idPrefix}
        showTitle={false}
        contactOnly
        formLabel={copy.title}
        submitLabel={copy.submit}
        requestType="book_demo"
        plan={plan}
        planLabel={planLabel}
        source={source || (plan ? `pricing-plan-${plan}` : 'pricing-consultation')}
        onSubmittingChange={setSubmitting}
      />
    </Modal>
  </>;
}
